var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ueEditorId-component"},[_c('div',{staticClass:"uePosition"},[_c('div',{attrs:{"id":_vm.ueEditorId}}),(_vm.ueSelfPreviwe)?_c('div',{staticClass:"previewBtn",style:({
        left: _vm.previewBtnWidth + 'px',
      }),on:{"click":function($event){return _vm.previewShow(true)}}},[_vm._v(" 预览 ")]):_vm._e(),_c('div',{staticClass:"marketCourse",style:({
        left: _vm.previewBtnWidth + 'px',
      })},[_vm._t("default")],2),(_vm.previewStatus)?_c('div',[_c('div',{staticClass:"preview_con",class:{
          active: _vm.previewCon,
        },on:{"click":function($event){return _vm.previewShow(false)}}},[_c('div',{staticClass:"preview_con",class:{
            active: _vm.previewCon,
          }},[_c('div',{staticClass:"preview_content",domProps:{"innerHTML":_vm._s(_vm.ueHtml)}})])])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }